export default __webpack_public_path__ + "static/media/draw-6.ff0f5906.jpg";